// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-statistics{margin:1em 0;gap:1em 1em}`, "",{"version":3,"sources":["webpack://./bs-ui/src/app/pages/labels/statistics/LabelStatistics.scss"],"names":[],"mappings":"AAAA,kBACE,YAAA,CACA,WAAA","sourcesContent":[".label-statistics {\n  margin: 1em 0;\n  gap: 1em 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
